import { useQuery } from "react-query";

import {
  getLocalStorageItem,
  PREVIOUS_VEHICLE_SEARCH_QUERY_KEY,
} from "../../helpers/localStorage";
import { APQueryOptions, useAPQuery } from "../../providers/APQueryProvider";

export const getPreviousVehicleSearchQuery = (options: APQueryOptions = {}) => {
  const { isQueryEnabled } = useAPQuery();

  return useQuery({
    queryKey: ["previous-vehicle-search-query"],
    queryFn: (): string | null => {
      return (
        getLocalStorageItem<string>(PREVIOUS_VEHICLE_SEARCH_QUERY_KEY) || null
      );
    },
    enabled: isQueryEnabled(options),
  });
};
